import React, { useEffect, useRef } from "react";
import styles from "./CardScroll.module.scss";
import { Colors } from "@factorearth/component-library/dist/Theme/types";

interface CardScrollProps {
	rowKey: string;
	rowHtml: React.JSX.Element[];
	color: Colors;
	visibleSection: string;
	isNewlyAdded?: boolean;
}
function CardScroll(props: CardScrollProps) {
	const { rowKey, rowHtml, color, visibleSection, isNewlyAdded } = props;

	const thisRef = useRef<null | HTMLDivElement>(null);

	useEffect(() => {
		if (visibleSection && visibleSection === rowKey) {
			if (thisRef?.current !== null) {
				thisRef.current.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
			}
		}
	}, [visibleSection]);

	return (
		<div
			// id={section}
			style={{ backgroundColor: color.background.secondary }}
			ref={thisRef}
			className={`${styles.intersection_list_item}${isNewlyAdded ? ` ${styles.newly_added}` : ""}`}>
			{rowHtml}
		</div>
	);
}

export default CardScroll;
